import { useQuery } from "@apollo/client"
import { ReportData, ReportOptions, ReportType } from ".."
import { GetTerminalReportQuery, GET_TERMINAL_REPORT } from "../graphql/queries/getTerminalReport"

export const useTerminalReport = (options: ReportType<ReportOptions, "terminal">) => {
  const { data, loading } = useQuery<GetTerminalReportQuery>(GET_TERMINAL_REPORT, {
    variables: {
      ids: options.apiTerminalIds,
    },
  })

  return {
    data:
      data &&
      ({
        type: "terminal",
        terminals: data?.terminals.edges ?? [],
      } as ReportType<ReportData, "terminal"> | undefined),
    loading,
  }
}
